import { render, staticRenderFns } from "./terminationtable.vue?vue&type=template&id=6e7be5fa"
import script from "./terminationtable.vue?vue&type=script&lang=js"
export * from "./terminationtable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports